// Â© 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import type { Mesh } from 'three'
import type { MachineDefinition, MachineDevice, MachineCollider } from '@core/machine'
import type { BuiltDevice } from './deviceMeshes'
import { registerSlingSurfaces, type PartPalette } from './partsKit'
import type asset from '../../SourceArt/SlingAssembly/mesh.json'
let data:typeof asset|undefined
let assemble:typeof import('./slingAssemblyBuild')['assembleSling']|undefined
let housing:typeof import('./slingAssemblyBuild')['makeSlingHousing']|undefined
/** Load authored mesh construction and optics when a machine needs them. */
export async function prepareSlingAssembly():Promise<void>{
  if(housing!==undefined)return
  registerSlingSurfaces((await import('./slingSurfaces')).createSlingSurface)
  data=(await import('./slingAssemblyBuild')).asset
  assemble=(await import('./slingAssemblyBuild')).assembleSling
  housing=(await import('./slingAssemblyBuild')).makeSlingHousing
}
export function withSlingAssembly(built:BuiltDevice,device:MachineDevice|import('../builder/parts').FlasherPart,definition:Pick<MachineDefinition,'machineId'> & Partial<Pick<MachineDefinition,'colliders'>>,palette:PartPalette):BuiltDevice{
  if(device.kind==='flasher')return built
  return assemble?.(built,device,definition,palette,data!)??built
}
export function slingHousing(definition:MachineDefinition,collider:MachineCollider,palette:PartPalette):Mesh|undefined{
  return housing?.(definition,collider,palette,data!)
}
